function formatToASCII(text) {
  const replacements = [
  // Single quotes
  [/[\u2018\u2019\u201B\u275B\u275C]/g, "'"],
  // Double quotes
  [/[\u201C\u201D\u201E\u201F]/g, '"'],
  // Dashes
  [/[\u2013\u2014]/g, '-'],
  // Ellipsis
  [/\u2026/g, '...'],
  // Bullet
  [/\u2022/g, '*'],
  // Spaces
  [/[\u00A0\u2009\u200A]/g, ' '],
  // Math symbols
  [/\u00D7/g, '*'],
  [/\u00F7/g, '/'],
  // Copyright and trademark
  [/\u00A9/g, '(c)'],
  [/\u00AE/g, '(r)'],
  [/\u2122/g, '(tm)'],
  // Additional punctuation
  [/\u2012/g, '-'], // figure dash
  [/\u2020/g, '+'], // dagger
  [/\u2021/g, '++'] // double dagger
  ];

  let formattedText = text;
  for (const [regex, replacement] of replacements) {
    formattedText = formattedText.replace(regex, replacement);
  }

  return formattedText;
}

export default formatToASCII;